import styled from 'styled-components/native';
import { withDefaultTypographyProps } from '@sp/ui/typography/index.shared';

const Title = styled(withDefaultTypographyProps)`
  font-size: ${(props) => props.theme.FONT_SIZES.SUBTITLE.DESKTOP}px;
`;

export default Title;
